import React from "react";
import Contact from "../components/Contact";
import Seo from "../components/Seo";

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact"
        path="/contact"
        description="Get in touch with Hirun Kolongahapitiya - software engineer based in Colombo, Sri Lanka. Open to full-stack roles, consulting, and collaborations. Reach out via email, WhatsApp, or LinkedIn."
      />
      <Contact />
    </>
  );
}
